import type { AxiosInstance, AxiosResponse } from 'axios';

import instantSurveyApi from './api';

const axios = instantSurveyApi as AxiosInstance;

interface PreviewSession {
  id: string;
}

interface CreatePreviewSessionPayload {
  quota_group_id?: string | number;
  starting_question_id?: number;
}

/**
 * Formats the preview selection data to match the API's expected payload structure.
 */
const formatPreviewSelection = ({
  questionId,
  quotaGroupId,
}: {
  questionId?: number;
  quotaGroupId?: string | number;
}) => {
  const data: CreatePreviewSessionPayload = {};
  if (quotaGroupId != null) data.quota_group_id = quotaGroupId;
  if (questionId != null) data.starting_question_id = questionId;
  return data;
};

/**
 * Creates a preview session for an instant survey based on the provided selection criteria.
 * Optionally starts at a specific question
 */
export const createPreviewSession = async ({
  instantSurveyId,
  previewSelection,
  signal,
}: {
  instantSurveyId: string | number;
  previewSelection: {
    questionId?: number;
    quotaGroupId?: string | number;
  };
  signal?: AbortSignal;
}): Promise<PreviewSession> => {
  return axios({
    data: formatPreviewSelection(previewSelection),
    method: 'post',
    signal,
    url: `/instantsurvey/instantsurvey/${instantSurveyId}/preview_session`,
  }).then(({ data }: AxiosResponse<PreviewSession>) => data);
};
